module.exports = __webpack_public_path__ + "img/img10.6e71de45.svg";